module.exports = __webpack_public_path__ + "img/38d0f343.b24d0bad.png";